function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.73709 12.768L6.73711 12.768C6.85978 12.896 7.04962 12.896 7.17235 12.768L6.73709 12.768ZM6.73709 12.768L1.4189 7.22112C1.28486 7.08131 1.28483 6.84622 1.41891 6.70635C1.41891 6.70634 1.41892 6.70634 1.41892 6.70633L2.57597 5.4995L2.57598 5.49949C2.69866 5.37152 2.88852 5.37152 3.0112 5.49949L3.01122 5.49951L6.59381 9.23611L6.95472 9.61254L7.31564 9.23611L14.9891 1.23269L14.6282 0.886653L14.9891 1.23269C15.1118 1.10473 15.3017 1.10473 15.4244 1.23269L16.5814 2.43953L16.9424 2.0935L16.5815 2.43953C16.7155 2.57934 16.7155 2.81443 16.5815 2.9543C16.5814 2.95431 16.5814 2.95432 16.5814 2.95432L7.17237 12.768L6.73709 12.768Z",
  fill: "#88BB1B",
  stroke: "#88BB1B"
});

const SvgIconSelect = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSelect, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-select.009ee20c.svg";
export { ForwardRef as ReactComponent };